import { useQuery } from "@tanstack/react-query";
import type { CategoryView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type UseCategoriesQueryParams = {
  storeSlug: string;
};

export function useCategoriesQuery({ storeSlug }: UseCategoriesQueryParams) {
  const query = useQuery({
    queryKey: queryKeys.seller.categories(storeSlug),
    queryFn: () => apiJsonClient<CategoryView[]>(endpoints.seller.categories),
    enabled: storeSlug.length > 0,
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
  };
}
